export enum GpsStatus {    
    PendingShip = 1,
    ShippedOut = 2,
    PendingGps = 8,
    CtrReceived = 3,
    InProcess = 4,
    ReturnReady = 5,
    ShippedBack = 6,
    NkrReceived = 7
}